import { IAutomationExecutionPeriodicStats, IAutomationLifecycleStats } from './AutomationStats';

export interface IAutomationSummary {
  automations: IAutomationLifecycleStats;
  executions: IAutomationExecutionPeriodicStats;
}

export interface IAutomationSummaryContext {
  programId?: number;
}
